import React from "react";

export let MaybeDevTools: React.FunctionComponent;

if (process.env.NODE_ENV === "development") {
  const TanStackDevtools = (await import("@tanstack/react-devtools")).TanStackDevtools;
  const TanStackRouterDevtoolsPanel = (await import("@tanstack/react-router-devtools"))
    .TanStackRouterDevtoolsPanel;
  MaybeDevTools = () => (
    <>
      <TanStackDevtools
        config={{
          position: "bottom-right",
        }}
        plugins={[
          {
            name: "TanStack Router",
            render: <TanStackRouterDevtoolsPanel />,
          },
        ]}
      />
    </>
  );
} else {
  MaybeDevTools = () => <React.Fragment />;
}
